import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import sam5 from '../../img/TopSakura.png';
import kaki from '../../img/Book1.jpg';
import question from '../../img/TopQuestion.JPEG';
import schedule from '../../img/TopSchedule.JPEG';
import sam8 from '../../img/TopFlow.JPEG';
import styled from 'styled-components';

const url = '/yotsutaninet/';

// ==================== Styled Components ====================

// お知らせセクション
const NewsSection = styled.div`
    margin: 0 auto;
    width: 80%;
    border: 0 !important;
    margin-bottom: 3rem;
`;

const NewsContainer = styled.div`
    display: flex;
    flex-direction: row;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    
    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const NewsHeader = styled.div`
    background-image: linear-gradient(0deg, #990820 0%, #ba0020 100%);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 70px 30px;
    min-width: 200px;
    
    @media (max-width: 768px) {
        padding: 30px;
        min-width: auto;
    }
    
    h3 {
        margin: 0;
        font-weight: bold;
        letter-spacing: 2px;
    }
`;

const NewsContent = styled.div`
    flex: 1;
    padding: 50px 40px;
    background-color: #fff;
    
    @media (max-width: 768px) {
        padding: 30px 20px;
    }
`;

// お知らせアイテム
const NewsItem = styled.div`
    margin-bottom: 2rem;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 1.5rem;
    
    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
        padding-bottom: 0;
    }
`;

const NewsItemHeader = styled.button`
    width: 100%;
    border: none;
    background: none;
    padding: 0;
    cursor: ${props => props.$clickable ? 'pointer' : 'default'};
    text-align: left;
    transition: all 0.3s ease;
    
    &:hover {
        ${props => props.$clickable && `
            transform: translateX(5px);
        `}
    }
`;

const NewsTitle = styled.h4`
    color: #333;
    margin: 0;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid indianred;
    display: inline-block;
    font-size: 1.1rem;
    font-weight: 600;
    width: 100%;
    
    a {
        color: #333;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 8px;
        
        &:hover {
            color: indianred;
        }
    }
`;

const HighlightTitle = styled(NewsTitle)`
    font-size: 1.3rem;
    
    .highlight-text {
        color: indianred;
        font-size: 1.5rem;
        font-weight: bold;
    }
`;

const ExpandIcon = styled.span`
    display: inline-block;
    transition: transform 0.3s ease;
    transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
    margin-left: 8px;
`;

const NewsDetails = styled.div`
    max-height: ${props => props.$isOpen ? '1000px' : '0'};
    opacity: ${props => props.$isOpen ? '1' : '0'};
    overflow: hidden;
    transition: all 0.4s ease;
    margin-top: ${props => props.$isOpen ? '1rem' : '0'};
`;

const NewsDetailList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    padding: 1rem;
    background-color: #f9f9f9;
    border-radius: 6px;
`;

const NewsDetailItem = styled.a`
    padding: 0.5rem 1rem;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    text-decoration: none;
    color: #333;
    font-weight: 500;
    transition: all 0.3s ease;
    
    &:hover {
        background-color: indianred;
        color: #fff;
        border-color: indianred;
        transform: translateY(-2px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
`;

// 合格実績表示エリア
const ResultsContent = styled.div`
    background: linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%);
    border-left: 4px solid indianred;
    padding: 1.5rem;
    border-radius: 6px;
    margin-top: 1rem;
    
    p {
        margin: 0.5rem 0;
        font-weight: 500;
        color: #333;
        line-height: 1.8;
        
        &:last-child {
            margin-top: 1rem;
            font-size: 0.9rem;
            color: #666;
        }
    }
`;

const PDFIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"/>
    </svg>
);

const ArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
    </svg>
);

// 各ページの案内セクション
const Introduction = styled.div`
    padding: 30px 0;
    margin: 30px 0;
    background-image: linear-gradient(0deg, #990820 0%, #ba0020 100%);
`;

const IntroductionGrid = styled.div`
    margin: 0 auto;
    width: 90%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

const IntroductionCard = styled(Link)`
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    display: block;
    transition: transform 0.3s ease;
    
    &:hover {
        transform: translateY(-5px);
        
        img {
            transform: scale(1.05);
        }
    }
    
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
    }
`;

const CardOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.3);
`;

const CardTitle = styled.h3`
    margin: auto;
    color: #fff;
    font-weight: bold;
    padding: 10px;
    border-radius: 7px;
    font-size: 35px;
    letter-spacing: 5px;
    background-color: ${props => props.$bgColor || 'transparent'};
    
    @media (max-width: 768px) {
        font-size: 24px;
        letter-spacing: 3px;
    }
`;

// ==================== お知らせデータ管理 ====================

const newsData = [
        {
        id: 'results',
        type: 'content',
        title: '2026年度',
        highlight: '合格速報',
        linkTo: url + 'Success',
        defaultOpen: true, // デフォルトで開いた状態
        content: (
            <>
                <p>土佐中学・・６名</p>
                <p>土佐塾中・・１名</p>
                <p>ラサール中学・・１名</p>
                <p>愛光中学・・４名</p>
                <p>同志社中学・・１名</p>
                <p>岡山中学(東医コース)・・２名</p>
                <p>岡山中学(難関コース)・・３名</p>
                <p></p>
                <p>はりまやYT教室生の合格実績です。</p>
            </>
        )
    },
        {
        id: 'spring',
        type: 'link',
        title: '夏期講座の時間割',
        link: 'https://www.tosajuku.com/28297e3df9b137d7d2694f1a3f6ec7cfa017659f.pdf'
    },
    {
        id: 'schedule',
        type: 'expandable', // Type: 'link' | 'expandable' | 'content'
        title: '2026年度　時間割・行事予定表',
        details: [
            { label: '6月の行事予定表', link: 'https://www.tosajuku.com/Schedule202606.pdf' },
            { label: '7月の行事予定表', link: 'https://www.tosajuku.com/Schedule202607.pdf' }
        ]
    },

    // {
    //     id: 'description',
    //     type: 'link',
    //     title: '教室説明会・入室テストのご案内',
    //     link: 'https://www.tosajuku.com/ytDescriptionParty2.pdf'
    // },
    {
        id: 'transition',
        type: 'expandable',
        title: 'YT生 「土佐塾模試 成績推移表」はこちら',
        details: [
            { 
                label: '4YTコース成績推移表', 
                link: 'https://www.tosajuku.com/transition2025Y4.pdf',
                icon: <PDFIcon />
            },
            { 
                label: '5YTコース成績推移表', 
                link: 'https://www.tosajuku.com/transition2025Y5.pdf',
                icon: <PDFIcon />
            },
            { 
                label: '6YTコース成績推移表', 
                link: 'https://www.tosajuku.com/transition2025Y6.pdf',
                icon: <PDFIcon />
            }
        ]
    }
];

// ==================== コンポーネント ====================

const NewsItemComponent = ({ item }) => {
    const [isOpen, setIsOpen] = useState(item.defaultOpen || false);

    // Type 1: 直接リンク
    if (item.type === 'link') {
        return (
            <NewsItem>
                <NewsItemHeader $clickable={false}>
                    <NewsTitle>
                        <a href={item.link} target="_blank" rel="noopener noreferrer">
                            {item.title}
                        </a>
                    </NewsTitle>
                </NewsItemHeader>
            </NewsItem>
        );
    }

    // Type 2: 展開可能なリスト
    if (item.type === 'expandable') {
        return (
            <NewsItem>
                <NewsItemHeader $clickable={true} onClick={() => setIsOpen(!isOpen)}>
                    <NewsTitle>
                        {item.link ? (
                            <a href={item.link} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                                {item.title}
                            </a>
                        ) : (
                            <span>{item.title}</span>
                        )}
                        <ExpandIcon $isOpen={isOpen}>
                            <ArrowIcon />
                        </ExpandIcon>
                    </NewsTitle>
                </NewsItemHeader>
                <NewsDetails $isOpen={isOpen}>
                    <NewsDetailList>
                        {item.details.map((detail, index) => (
                            <NewsDetailItem 
                                key={index} 
                                href={detail.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {detail.icon && <span style={{ marginRight: '6px' }}>{detail.icon}</span>}
                                {detail.label}
                            </NewsDetailItem>
                        ))}
                    </NewsDetailList>
                </NewsDetails>
            </NewsItem>
        );
    }

    // Type 3: コンテンツ表示（合格実績など）
    if (item.type === 'content') {
        return (
            <NewsItem>
                <NewsItemHeader $clickable={false}>
                    <HighlightTitle>
                        {item.linkTo ? (
                            <Link to={item.linkTo} style={{ color: '#333', textDecoration: 'none' }}>
                                {item.title} <span className="highlight-text">{item.highlight}</span>はこちら
                            </Link>
                        ) : (
                            <span>{item.title} <span className="highlight-text">{item.highlight}</span></span>
                        )}
                    </HighlightTitle>
                </NewsItemHeader>
                <ResultsContent>
                    {item.content}
                </ResultsContent>
            </NewsItem>
        );
    }

    return null;
};

// ==================== メインコンポーネント ====================

const Main = () => {
    return (
        <>
            {/* お知らせセクション */}
            <NewsSection>
                <NewsContainer>
                    <NewsHeader>
                        <h3>お知らせ</h3>
                    </NewsHeader>
                    <NewsContent>
                        {newsData.map((item) => (
                            <NewsItemComponent key={item.id} item={item} />
                        ))}
                    </NewsContent>
                </NewsContainer>
            </NewsSection>

            {/* 各ページの案内 */}
            <Introduction>
                <IntroductionGrid>
                    <IntroductionCard to={url + 'Join'}>
                        <img src={sam8} alt="入塾の流れ" />
                        <CardOverlay>
                            <CardTitle>入塾の流れ</CardTitle>
                        </CardOverlay>
                    </IntroductionCard>

                    <IntroductionCard to={url + 'TrialRecord'}>
                        <img src={sam5} alt="合格体験記" />
                        <CardOverlay>
                            <CardTitle $bgColor="lightpink">合格体験記</CardTitle>
                        </CardOverlay>
                    </IntroductionCard>

                    <IntroductionCard to={url + 'Faq'}>
                        <img src={question} alt="よくあるご質問" />
                        <CardOverlay>
                            <CardTitle>よくあるご質問</CardTitle>
                        </CardOverlay>
                    </IntroductionCard>

                    <IntroductionCard to={url + 'Information'}>
                        <img src={schedule} alt="月間スケジュール" />
                        <CardOverlay>
                            <CardTitle>月間スケジュール</CardTitle>
                        </CardOverlay>
                    </IntroductionCard>
                </IntroductionGrid>
            </Introduction>
        </>
    );
};

export default Main;
